module.exports = __webpack_public_path__ + "img/spain.fed7d0ce.png";